import React from 'react';

const PeopleTab = ({ classroomDetails }) => {
  const { teachers, students } = classroomDetails;

  return (
    <div className="people-tab">
      <h2>Teachers</h2>
      <hr />
      {teachers.map(teacher => (
        <p key={teacher.id}>{teacher.email}</p>
      ))}
      <h2 style={{marginTop: '40px'}}>Students ({students.length})</h2>
      <hr />
      <ul>
        {students.map(student => (
          <li key={student.id}>{student.email}</li>
        ))}
      </ul>
    </div>
  );
};

export default PeopleTab;